import { gql } from '@apollo/client';

export const DIGITAL_SCORE_REPORT = gql`
  query DigitalScoreReportURL($digitalDocumentKey: String!) {
    digitalScoreReportURL(digitalDocumentKey: $digitalDocumentKey)
  }
`;
